// components/Footer.js
import React from 'react';
import './Footer.css';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  
  const menuItems = [
    { id: 1, name: 'Tableau de bord', icon: '📊', path: '/dashboard' },
    { id: 6, name: 'En Tete', icon: '👨‍💼', path: '/en-tete' },
     { id: 6, name: 'Top', icon: '🎉', path: '/top10' },
    { id: 8, name: 'Paramètres', icon: '⚙️', path: '/settings' }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="footer mt-5" style={{marginTop:'20px'}}>
      {menuItems.map(item => (
        <Link 
          key={item.id} 
          to={item.path} 
          className={`footer-item ${isActive(item.path) ? 'active' : ''}`}
        >
          <div className="footer-icon">{item.icon}</div>
          <span className="footer-text">{item.name}</span>
        </Link>
      ))}
    </div>
  );
};

export default Footer;